import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfCopilotPositiveSentimentIconProps extends SvgIconProps {}

/**
 * Component used to display copilot positive sentiment icon
 * @param props - CcfCopilotPositiveSentimentIconProps
 * @returns
 * @example
 */
export function CcfCopilotPositiveSentimentIcon(
  props: CcfCopilotPositiveSentimentIconProps
) {
  return (
    <SvgIcon width="24" height="25" viewBox="0 0 24 25" fill="none" {...props}>
      <g clip-path="url(#clip0_2278_6093)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.25484 18.6631C5.48264 18.8909 5.85199 18.8909 6.0798 18.6631L8.91983 15.8231C9.04214 15.7008 9.10939 15.6342 9.16141 15.59C9.16348 15.5883 9.16545 15.5866 9.16732 15.5851C9.16919 15.5866 9.17116 15.5883 9.17323 15.59C9.22525 15.6342 9.29249 15.7008 9.4148 15.8231L11.0247 17.433C11.1288 17.5371 11.2302 17.6385 11.323 17.7173C11.425 17.8039 11.5545 17.897 11.7235 17.9519C11.9578 18.0281 12.2102 18.0281 12.4445 17.9519C12.6135 17.897 12.7429 17.8039 12.8449 17.7173C12.9378 17.6385 13.0392 17.5371 13.1433 17.433L16.7506 13.8256V16.5007C16.7506 16.8228 17.0118 17.084 17.334 17.084C17.6561 17.084 17.9173 16.8228 17.9173 16.5007V12.4173C17.9173 12.0952 17.6561 11.834 17.334 11.834H13.2507C12.9285 11.834 12.6673 12.0952 12.6673 12.4173C12.6673 12.7395 12.9285 13.0007 13.2507 13.0007H15.9257L12.3315 16.5949C12.2092 16.7172 12.1419 16.7838 12.0899 16.8279C12.0878 16.8297 12.0859 16.8314 12.084 16.8329C12.0821 16.8314 12.0801 16.8297 12.0781 16.8279C12.0261 16.7838 11.9588 16.7172 11.8365 16.5949L10.2266 14.985C10.1225 14.8809 10.0211 14.7795 9.92827 14.7006C9.82627 14.614 9.69684 14.521 9.52784 14.466C9.29352 14.3899 9.04111 14.3899 8.8068 14.466C8.6378 14.521 8.50836 14.614 8.40637 14.7006C8.31349 14.7795 8.21211 14.8809 8.10802 14.985C8.10364 14.9894 8.09926 14.9938 8.09487 14.9981L5.25484 17.8382C5.02703 18.066 5.02703 18.4353 5.25484 18.6631Z"
          fill="#008940"
          stroke="#008940"
          strokeWidth="0.35"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        opacity="0.16"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 9.92767C21.0129 10.6936 19.7732 11.1496 18.4271 11.1496C15.2054 11.1496 12.5938 8.5379 12.5938 5.31624C12.5938 4.49323 12.7642 3.71002 13.0717 3H3.33333C2.04467 3 1 4.04467 1 5.33333V21.6667C1 22.9553 2.04467 24 3.33333 24H19.6667C20.9553 24 22 22.9553 22 21.6667V9.92767Z"
        fill="#1ED990"
      />
      <g clip-path="url(#clip1_2278_6093)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.7442 1.79039C18.6937 1.65898 18.5674 1.57227 18.4266 1.57227C18.2859 1.57227 18.1596 1.65898 18.1091 1.79039L17.4244 3.57041C17.3222 3.83618 17.2901 3.91277 17.2461 3.97456C17.2021 4.03656 17.1479 4.09073 17.0859 4.13482C17.0241 4.17876 16.9475 4.21088 16.6817 4.3131L14.9017 4.99772C14.7703 5.04827 14.6836 5.17452 14.6836 5.31532C14.6836 5.45612 14.7703 5.58237 14.9017 5.63292L16.6817 6.31754C16.9475 6.41976 17.0241 6.45188 17.0859 6.49582C17.1479 6.53991 17.2021 6.59408 17.2461 6.65608C17.2901 6.71787 17.3222 6.79446 17.4244 7.06023L18.1091 8.84025C18.1596 8.97166 18.2859 9.05838 18.4266 9.05838C18.5674 9.05838 18.6937 8.97166 18.7442 8.84025L19.4289 7.06023C19.5311 6.79446 19.5632 6.71787 19.6071 6.65608C19.6512 6.59408 19.7054 6.53991 19.7674 6.49582C19.8292 6.45188 19.9058 6.41976 20.1716 6.31754L21.9516 5.63292C22.083 5.58237 22.1697 5.45612 22.1697 5.31532C22.1697 5.17452 22.083 5.04827 21.9516 4.99772L20.1716 4.3131C19.9058 4.21088 19.8292 4.17876 19.7674 4.13482C19.7054 4.09073 19.6512 4.03656 19.6071 3.97456C19.5632 3.91277 19.5311 3.83619 19.4289 3.57041L18.7442 1.79039Z"
          fill="#008940"
        />
      </g>
      <defs>
        <clipPath id="clip0_2278_6093">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="matrix(1 0 0 -1 4.5 23.5)"
          />
        </clipPath>
        <clipPath id="clip1_2278_6093">
          <rect
            width="8.16667"
            height="8.16667"
            fill="white"
            transform="translate(14.3438 1.23242)"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}

export default CcfCopilotPositiveSentimentIcon;
